import React from "react";
import { LegendProps } from "recharts";

import { IgChip } from "@intelligems/ig-theme";
import Grid from "@mui/material/Grid";
import { AnalyticsLegendIcon } from "@src/images/Icons/AnalyticsLegendIcon";

export const IgStackedHorizBarLegend = (props: LegendProps) => {
  if (!props.payload) return null;

  return (
    <Grid container direction={"row"}>
      {props.payload.map((pay, index) => (
        <Grid key={`${pay.value}-${index}`}>
          <IgChip
            variant={"outlined"}
            icon={
              <AnalyticsLegendIcon
                sx={{
                  width: "10px",
                  height: "10px",
                  paddingLeft: "4px",
                }}
                fill={pay.color}
              />
            }
            sx={{
              borderColor: "transparent",
              fontWeight: 400,
              backgroundColor: "transparent",
              minWidth: "50px",
              fontSize: "12px",
              height: "30px",
            }}
            label={pay.value || ""}
          />
        </Grid>
      ))}
    </Grid>
  );
};
